import { parseDate } from '@/utilities/Date/parse'

export const computed = {
  observationDateParsed() {
    return parseDate(this.observationDate, 'LL')
  }
}
